import { createSlice } from '@reduxjs/toolkit';
import { createThunkHttp } from '../../services/helpers/thunk';

import { httpGetWebsite } from '../../services/http';

export const selectWebsiteId = (state) => state.website.website_id;
export const selectWebsiteLoaded = (state) => state.website.isWebsiteLoaded;
export const selectWebsiteTheme = (state) => state.website.theme;
export const selectWebsiteFont = (state) => state.website.font;
export const selectWebsiteLng = (state) => state.website.lng;
export const selectWebsiteError = (state) => state.website.error;

export const getWebsite = createThunkHttp(
  'website/getWebsite',
  httpGetWebsite,
);

const initialState = {
  website_id: null,
  websiteInfo: null,
  isWebsiteLoaded: false,
  font: {
    font_id: 'WLy0o4O',
    name: 'Modern',
    code_name: 'modern',
    header_font: 'Changa One',
    body_font: 'PT Sans',
    header_font_url: 'https://fonts.googleapis.com/css?family=Changa+One',
    body_font_url: 'https://fonts.googleapis.com/css?family=PT+Sans',
  },
  theme: {
    theme_id: 'OE6q2vd',
    name: 'Gray-Green',
    code_name: 'graygreen',
    colors: [
      {
        theme_color_id: 'om4WA68',
        color: '#FFFFFF',
      },
      {
        theme_color_id: 'KJvQMvW',
        color: '#F3F2F2',
      },
      {
        theme_color_id: 'bN4eDvB',
        color: '#EBF2F4',
      },
      {
        theme_color_id: 'GkvGB6W',
        color: '#D5E7EC',
      },
      {
        theme_color_id: 'Ly0oo4O',
        color: '#5C6C74',
      },
      {
        theme_color_id: 'n6lGnyo',
        color: '#444444',
      },
      {
        theme_color_id: 'W4mnQy2',
        color: '#5893A7',
      },
      {
        theme_color_id: 'L6bN36p',
        color: '#35748A',
      },
    ],
  },
  lng: null,
  error: false,
};

export const websiteSlice = createSlice({
  name: 'website',
  initialState,
  reducers: {
    setWebsite: (state, action) => {
      state.website_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWebsite.pending, (state) => {
        state.error = false;
        state.isWebsiteLoaded = false;
      })
      .addCase(getWebsite.fulfilled, (state, action) => {
        state.websiteInfo = action.payload;
        state.theme = action.payload.theme;
        state.font = action.payload.font;
        state.lng = action.payload.lang;
        state.isWebsiteLoaded = true;
      })
      .addCase(getWebsite.rejected, (state) => {
        state.lng = 'en';
        state.error = true;
      });
  },
});

export const { setWebsite } = websiteSlice.actions;

export default websiteSlice.reducer;
